const serviceName = `/service/tree`
export default serviceName
